// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"db6168b6","124":"5958b9a1","488":"2341a5a9","671":"db882c36","779":"0e7dbc51","784":"eaf91518"}[chunkId] + ".chunk.js";
};